import { useUserSheet } from "../userSheetContext";
import type { UserSheetCommsCandidacy } from "../types";

import { useGetCandidacyInfo } from "@/hooks/queries/useGetCandidacyInfo";
import { useGetCandidacySheetData } from "@/hooks/queries/useGetCandidacySheetData";

// Assembles the slim candidacy the comms components need from candidacy-info
// (candidacy scalars) and the nova profile (name, phone). Undefined until the
// info loads, and always undefined on non-candidacy sheets (search).
export const useCommsCandidacy = (): UserSheetCommsCandidacy | undefined => {
  /* Context */
  const { candidacyId, jobId, workerId } = useUserSheet();

  /* Database CRUD Operations */
  // Read
  const candidacyInfo = useGetCandidacyInfo({
    candidacyId: candidacyId ?? "",
  }).data;
  const profile = useGetCandidacySheetData({ jobId, userId: workerId }).data;

  /* Helpers */
  if (!candidacyId || !candidacyInfo) return undefined;

  return {
    firstName: profile?.profile.firstName ?? null,
    id: candidacyId,
    lastName: profile?.profile.lastName ?? null,
    // The candidacy phone-of-record keys the quo thread; the live nova phone
    // is only a fallback until guac /info returns it.
    phone: candidacyInfo.phone ?? profile?.profile.phone ?? null,
    stafferAgentActive: candidacyInfo.stafferAgentActive,
    status: candidacyInfo.status,
    talentId: candidacyInfo.talentId ?? null,
  };
};
